The identifier of the advertisement product.
